import createIcon from '../../createIcon';

/**
 * @component @name AddHome
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNSAxMEMxNy4yIDEwIDE3Ljg3IDEwLjEgMTguNSAxMC4yOVY4TDEwLjUgMkwyLjUgOFYyMEgxMC4xOEM5Ljc1IDE5LjA5IDkuNSAxOC4wOCA5LjUgMTdDOS41IDEzLjEzIDEyLjYzIDEwIDE2LjUgMTBaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTYuNSAxMkMxMy43NCAxMiAxMS41IDE0LjI0IDExLjUgMTdDMTEuNSAxOS43NiAxMy43NCAyMiAxNi41IDIyQzE5LjI2IDIyIDIxLjUgMTkuNzYgMjEuNSAxN0MyMS41IDE0LjI0IDE5LjI2IDEyIDE2LjUgMTJaTTE5LjUgMTcuNUgxN1YyMEgxNlYxNy41SDEzLjVWMTYuNUgxNlYxNEgxN1YxNi41SDE5LjVWMTcuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AddHome = createIcon('AddHome', [
  [
    'path',
    {
      d: 'M16.5 10C17.2 10 17.87 10.1 18.5 10.29V8L10.5 2L2.5 8V20H10.18C9.75 19.09 9.5 18.08 9.5 17C9.5 13.13 12.63 10 16.5 10Z',
      key: '1uuo42',
    },
  ],
  [
    'path',
    {
      d: 'M16.5 12C13.74 12 11.5 14.24 11.5 17C11.5 19.76 13.74 22 16.5 22C19.26 22 21.5 19.76 21.5 17C21.5 14.24 19.26 12 16.5 12ZM19.5 17.5H17V20H16V17.5H13.5V16.5H16V14H17V16.5H19.5V17.5Z',
      key: '1ftq0o',
    },
  ],
]);

export default AddHome;
